
import axios from '../../helpers/private.axios'



export const getApplicationAgreementDocuments = ( application_id ) => {

    return axios.get(`/api/documents/application/${application_id}`);
}